import MainLayout from "../layout";
import Page from "../page/Page";
import { useTranslation } from "react-i18next";

function Admissions() {
  const { t } = useTranslation();
  let title = {
    caption: t("pages.addmission.title"),
  };

  return (
    <MainLayout title={title}>
      <Page title={t("pages.addmission.title")} titleKey="pages.addmission.title" isWidthSmall={true}>
        <div data-key="pages.addmission.text" dangerouslySetInnerHTML={{ __html: t("pages.addmission.text") }}></div>
      </Page>
    </MainLayout>
  );
}

export default Admissions;
